import React, { useRef, useState, useEffect } from "react";
import "./navbar.css";
import song from "../assets/ScreenRecording_03-07-2026 22-51-38_1.mp3";

const Navbar = ({ autoPlayMusic }) => {

const audioRef = useRef(null);
const [isPlaying,setIsPlaying] = useState(false);

useEffect(() => {

const playMusic = async () => {

if(autoPlayMusic && audioRef.current){

try{
await audioRef.current.play();
setIsPlaying(true);
}catch(error){
console.log("Audio blocked");
}

}

};

playMusic();

},[autoPlayMusic]);

const handleMusicToggle = async () => {

if(!audioRef.current) return;

try{

if(isPlaying){
audioRef.current.pause();
setIsPlaying(false);
}else{
await audioRef.current.play();
setIsPlaying(true);
}

}catch(error){
console.log("Audio play blocked");
}

};

return (

<header className="navbar">

<div className="overlay"></div>

<div className="navbar-content">

<div className="logo">Umm Kulthum</div>

<nav className="nav-links">
<a href="#home">Home</a>
<a href="#about">About</a>
<a href="#songs">Songs</a>
<a href="#gallery">Gallery</a>
<a href="#quote">Quote</a>
</nav>

<button className="music-btn" onClick={handleMusicToggle}>

{isPlaying ? (
<>
<span></span>
<span></span>
</>
) : (
<div className="play-icon"></div>
)}

</button>

<audio
ref={audioRef}
src={song}
onEnded={() => setIsPlaying(false)}
></audio>

</div>

</header>

);

};

export default Navbar;